class TakeCustomerPresentCardPaymentError extends Error {
  constructor({ data }, ...params) {
    super('Could not process the given card payment', ...params);

    this.data = data;
  }
}

export default TakeCustomerPresentCardPaymentError;
